import { useEffect, useState } from 'react';
import { ModemData } from '../../api/Drone';
import { APIRequestGet } from '../../utils/APIRequests';
import { AstraUserSubscriptionData, AstraUserSubscriptionSchema } from './api/AstraSubscription';

/** Подписка выбранного модема; null, пока не загружена или её нет. */
function useModemSubscription(drone: ModemData): AstraUserSubscriptionData | null {
    const [subscription, setSubscription] = useState<AstraUserSubscriptionData | null>(null);

    useEffect(() => {
        setSubscription(null);
        APIRequestGet(`/astraSubscription/getSubscription?modemId=${drone.id}`, {
            schema: AstraUserSubscriptionSchema,
            logSuccess: true
        }).then((result) => {
            setSubscription(result.data);
        });
    }, [drone]);

    return subscription;
}

export default useModemSubscription;
